// Associate feature data layer — builds on the shared host-bridge client.
// Ported from v1 AssociateNetworkAPI + reducer LOAD_VIEW/LOAD_DATA data ops.

import { getAPIGatewayDataFromParent, getStationCode } from '../../handler/ParentDataHandler';

export interface AssociateMetric {
  alias: string;
  email: string;
  location: string;
  hourSpent: string;
  packageHandled: number;
  PPH: number;
  active: string; // 'Yes' | 'No'
}

export interface ScanDataPoint {
  timeStampVal: number;
  metricValue: number;
}

/** granularity -> associateEmail -> datapoints */
export type ScanMetricMap = Record<string, Record<string, ScanDataPoint[]>>;

interface RawAssociateMetric extends Omit<AssociateMetric, 'active'> {
  active: boolean | string;
}

/** Per-associate performance for the station. Normalizes exactly as v1. Returns [] on failure. */
export async function getAssociateMetric(nodeId: string = getStationCode()): Promise<AssociateMetric[]> {
  try {
    const result = await getAPIGatewayDataFromParent<{ associateMetricList?: RawAssociateMetric[] }>({
      resourcePath: '/ivs/getAssociateMetric',
      httpMethod: 'post',
      processName: 'induct',
      requestBody: { nodeId },
    });
    if (result?.status === 200) {
      const list = result.data?.associateMetricList ?? [];
      return list
        .filter((a) => (a?.packageHandled ?? 0) > 0)
        .map((a) => ({ ...a, alias: (a.alias ?? '').toLowerCase(), active: a.active ? 'Yes' : 'No' })) as AssociateMetric[];
    }
    return [];
  } catch {
    return [];
  }
}

/** Per-associate scan metrics keyed by granularity. Returns {} on failure. */
export async function getAssociateScanMetric(nodeId: string = getStationCode()): Promise<ScanMetricMap> {
  try {
    const result = await getAPIGatewayDataFromParent<{ associateScanMetricResponseMap?: ScanMetricMap }>({
      resourcePath: '/ivs/getAssociateScanMetric',
      httpMethod: 'post',
      processName: 'induct',
      requestBody: { nodeId },
    });
    if (result?.status === 200) {
      return result.data?.associateScanMetricResponseMap ?? {};
    }
    return {};
  } catch {
    return {};
  }
}
